/**
 * @generated SignedSource<<d58ea153d654ef497fb601c027a53b52>>
 * @relayHash f25f6c69f7df3cc8b9f619a0b3dea87f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 55ec1cf07f5468a3729ecf270bd81bf035b3c010d9d2c523421d6d43d8857f55

import type { ConcreteRequest } from 'relay-runtime';
export type useMigratorPromptEligibleAABMigratorPromptQuery$variables = Record<PropertyKey, never>;
export type useMigratorPromptEligibleAABMigratorPromptQuery$data = {
  readonly adminAnnouncementBannerSettingsByCriteria: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    } | null | undefined>;
  } | null | undefined;
};
export type useMigratorPromptEligibleAABMigratorPromptQuery = {
  response: useMigratorPromptEligibleAABMigratorPromptQuery$data;
  variables: useMigratorPromptEligibleAABMigratorPromptQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Literal",
        "name": "isAscending",
        "value": false
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "DEFAULT"
      }
    ],
    "concreteType": "AdminAnnouncementBannerSettingConnection",
    "kind": "LinkedField",
    "name": "adminAnnouncementBannerSettingsByCriteria",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceAdminAnnouncementBannerSetting",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ],
    "storageKey": "adminAnnouncementBannerSettingsByCriteria(first:1,isAscending:false,orderBy:\"DEFAULT\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useMigratorPromptEligibleAABMigratorPromptQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useMigratorPromptEligibleAABMigratorPromptQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f25f6c69f7df3cc8b9f619a0b3dea87f",
    "id": "55ec1cf07f5468a3729ecf270bd81bf035b3c010d9d2c523421d6d43d8857f55",
    "metadata": {},
    "name": "useMigratorPromptEligibleAABMigratorPromptQuery",
    "operationKind": "query",
    "text": "query useMigratorPromptEligibleAABMigratorPromptQuery{adminAnnouncementBannerSettingsByCriteria(first:1,orderBy:DEFAULT,isAscending:false){nodes{id}}}"
  }
};
})();

(node as any).hash = "bd3194ed3bdf2af28565248ad52e5bea";

export default node;
